/**
 * Districts and schools created before a field became required are allowed to keep their
 * missing values, otherwise the new rule would lock an old record out of being edited at all.
 *
 * So on an edit form a field is only required when the record was loaded with a value for it:
 * filling one in is encouraged, but only clearing one that was there is an error.  This mirrors
 * what the server enforces, so the Save button agrees with what a save would actually do.
 *
 * @param currentValue what the form holds now
 * @param valueWhenLoaded what the record held when the form opened
 */
export function isMissingRequiredValue(
	currentValue: string | number | undefined,
	valueWhenLoaded: string | number | undefined
): boolean {
	return !currentValue && !!valueWhenLoaded;
}
